import { useMemo } from 'react';
import { useQuery } from 'urql';

import { CreatorDiscoveryInstagramAccount } from '@frontend/app/hooks';
import { InstagramCreator } from '@frontend/gql/social/graphql';

import { discoverInstagramCreators } from '../graphql';

interface UseInstagramSimilarCreatorsProps {
  username: string;
  limit?: number;
  clientId?: string;
  instagramAccount?: CreatorDiscoveryInstagramAccount;
}

interface UseInstagramSimilarCreatorsReturn {
  creators: InstagramCreator[];
  fetching: boolean;
  error: Error | null;
}

export const useInstagramSimilarCreators = ({
  username,
  limit = 10,
  clientId,
  instagramAccount,
}: UseInstagramSimilarCreatorsProps): UseInstagramSimilarCreatorsReturn => {
  const igUserId = instagramAccount?.igUserId;
  const shouldPause = !username || !clientId || !igUserId;

  const [{ data, fetching, error }] = useQuery({
    query: discoverInstagramCreators,
    variables: {
      clientId,
      igUserId,
      similarToCreators: [username],
      limit,
    },
    pause: shouldPause,
  });

  const creators = useMemo(() => {
    if (shouldPause) {
      return [];
    }
    return data?.discoverInstagramCreators?.creators || [];
  }, [data?.discoverInstagramCreators?.creators, shouldPause]);

  return {
    creators,
    fetching: shouldPause ? false : fetching,
    error: shouldPause ? null : error,
  };
};
